<template>
  <BaseContainer class="flex flex-col gap-4 px-4 py-2">
    <div v-if="program.knowledgeables?.length">
      <ProgramKnowledgeables :knowledgeables="program?.knowledgeables" />
    </div>
    <base-flex-spinner v-if="isLoading" />
    <div
      v-if="attachments?.length"
      class="flex flex-col gap-4"
    >
      <div class="my-4">
        <h1 class="mb-4">
          Ressources pharmacien
        </h1>
        <attachment-grid
          :attachments="attachmentsByEntity(attachments,'healthcenter')"
          :attachable-id="program.id"
          attachable-type="programs"
        />
      </div>
      <div class="my-4">
        <div class="mb-4">
          <h1>Ressources patient</h1>
          <span>Vos patients auront accès à ces ressources depuis l'application mobile Apodis.</span>
        </div>
        <attachment-grid
          :attachments="attachmentsByEntity(attachments,'patient')"
          :attachable-id="program.id"
          attachable-type="programs"
        />
      </div>
    </div>
    <div v-else>
      <p>Aucune ressource liée à ce programme</p>
    </div>
  </BaseContainer>
</template>

<script lang="ts">
import {programAttachmentApi} from '@/container';
import BaseContainer from '@/core/components/base/BaseContainer.vue';
import AttachmentGrid from '@/attachment/components/AttachmentGrid.vue';
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {PropType} from "vue";
import {Program} from "@/program/interfaces/Program";
import ProgramKnowledgeables from "@/program/components/program-knowledgeables/ProgramKnowledgeables.vue";
import {Attachment} from "@/attachment/interfaces/attachment";

export default {
    name: 'ProgramDetailAttachments',
    components: {ProgramKnowledgeables, BaseFlexSpinner, AttachmentGrid, BaseContainer},
    props: {
        program: {
            type: Object as PropType<Program>,
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            attachments: []
        };
    },
    watch: {
        'program': {
            immediate: true,

            handler(value: Program) {
                this.index(value.id);
            }
        }
    },
    methods: {
        /**
         * Get the attachment index for the given program.
         *
         * @param {Number} programId - The program id.
         */
        index(programId: number) {
            programAttachmentApi()
                .attachmentIndex('programs', programId)
                .then(attachments => {
                    this.attachments = attachments;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        /**
         * Get the attachments group by entity.
         */
        attachmentsByEntity(attachments: Attachment[], entitySlug: string) {
            return attachments.filter(attachment => {
                return attachment.entity_types.find(entity => entity.slug === entitySlug);
            });
        },
    }
};
</script>
